// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productTypeDialog[data-v-660916c4] .el-dialog {\n  margin-left: 50px !important;\n  width: 800px !important;\n}\n#left[data-v-660916c4] {\n  width: 500px;\n}\n#left[data-v-660916c4] #middle {\n    width: 500px;\n    height: 300px;\n}\n#right[data-v-660916c4] {\n  margin-left: 30px;\n  margin-top: 30px;\n}\n#right > p[data-v-660916c4] {\n    margin-top: 6px;\n}\n", ""]);
// Exports
module.exports = exports;
